import styled from 'styled-components';
import moment from 'moment-timezone'
import isArray from 'lodash/isArray';
import FieldRadio from 'hive-admin/src/components/FieldRadio';
import getFilterWithCol from '../../helpers/getFilterWithCol';
import { filterSortCreatedUpdatedName } from '../../components/common';
import Types from '../../modules/types';
import clickAnchor from '../../helpers/clickAnchor';

const RadioComponent = styled(FieldRadio.config.Component)`
  display: flex;
  width: 100%;
  > .ant-radio-button-wrapper {
    flex: 1;
    flex-shrink: 1;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: auto;
    line-height: 100%;
    display: flex;
    padding: 8px 5px;
    white-space: nowrap;
  }
`;

function calculateTotalBalance(stores) {
  return stores.reduce((total, store) => {
      const balance = parseFloat(store.balance) || 0; // Fallback to 0 if balance is invalid
      return total + balance;
  }, 0);
}

export const generateCycleButton = ['FilterField', {
  name: 'generate Cycle',
  label: null,
  section: 'top',
  buildQuery: () => { },
  // eslint-disable-next-line max-len
  propsFromPage: ({
    client, queryBuilder, restBaseServer, searchParams, viewer,
    ...restProps
  }) => ({
    client,
    queryBuilder,
    restBaseServer,
    searchParams,
    viewer,
    restProps,
  }),
  field: ['Action', {
    name: 'generate Cycle',
    title: 'generate Cycle',
    // icon: 'download',
    type: 'default',
    style: { width: '100%' },
    onClick: (props) => {
      const { client, restProps } = props;
      const { periodRange } = restProps.getFilterParams();
      const periodRangeArr = periodRange.split(',');
      const accessToken = client.getAccessToken();
      const { data } = restProps.data;
      console.log(data, '---restProps');
      client.request({
        url: `/cycles?${
          accessToken
          ? `?access_token=${accessToken}`
          : ''
        }`,
        method: 'POST',
        data: {
          startDate: new Date(periodRangeArr[0]),
          endDate: new Date(periodRangeArr[1]),
          cycleData: data,
          total: calculateTotalBalance(data),
        },
      }).then(async (response) => {
        const resData = response.data;
      })
    },
    // ...fieldConfig,
  }],
}];

export const filterPeriodRange = ['FilterField', {
  id: 'periodRange',
  label: null,
  section: 'top',
  placeholder: ['From Date', 'To Date'],
  propsFromPage: props => ({
    searchParams: props.searchParams,
    history: props.history,
  }),
  ranges: {
    ...[
      ['Today', 0],
      ['Last 7 Days', 7],
      ['Last 30 Days', 30],
      ['Last 60 Days', 60],
      ['Last 90 Days', 90],
      ['Last 180 Days', 180],
    ].reduce(
      (agr, [label, daysOffset = null]) => {
        agr[label] = () => {
          const now = moment();
          return [
            now.clone().subtract(Math.max(0, daysOffset - 1), 'days'),
            now,
          ];
        };
        return agr;
      },
      {},
    ),
    ...[
      ['Week', 'week'],
      ['Month', 'month'],
      ['Year', 'year'],
    ].reduce(
      (agr, [label, value]) => {
        agr[`This ${label}`] = [
          moment().startOf(value),
          moment().endOf(value),
        ];
        agr[`Past ${label}`] = [
          moment().subtract(1, value).startOf(value),
          moment().subtract(1, value).endOf(value),
        ];
        agr[`2 ${label}s Ago`] = [
          moment().subtract(2, value).startOf(value),
          moment().subtract(2, value).endOf(value),
        ];
        return agr;
      },
      {},
    ),
  },
  buildQuery: (value, builder, filter, _2, { pageProps }) => {
    const now = moment();
    const isSideB = filter.id.indexOf('b.') === 0
    const whereKey = isSideB ? 'whereB' : 'where';
    const dateKeyRaw = (
      isSideB
        ? pageProps.searchParams.b?.date
        : pageProps.searchParams.date
    );
    const dateKey = 'completedAt';
    if (
      value
      && value.length
    ) {
      const values = (
        value
          .split(',')
          .map(dateString => (
            moment(dateString, 'YYYY-MM-DD')
            // .hour(now.hour())
            // .minute(now.minute())
            // .second(now.second())
            // .millisecond(now.millisecond())
          ))
      );
      if (
        values.length === 2
        && values[0] && values[0].isValid()
        && values[1] && values[1].isValid()
      ) {
        builder.add(
          whereKey,
          {
            [dateKey]: {
              GTE: values[0].startOf('day').toJSON(),
              LTE: values[1].endOf('day').toJSON(),
            },
          },
        );
        return;
      }
    }
    builder.add(
      whereKey,
      {
        [dateKey]: {
          GTE: (
            filter.defaultDateFrom
              ? moment(filter.defaultDateFrom).toJSON()
              : now.clone().startOf('month').toJSON()
          ),
          LTE: (
            filter.defaultDateTo
              ? moment(filter.defaultDateTo).toJSON()
              : now.endOf('day').toJSON()
          ),
        },
      },
    );
  },
  getValueForField: (value, props) => {
    const now = moment();
    if (value && value.length) {
      const values = (
        value
          .split(',')
          .map(dateString => (
            moment(dateString, 'YYYY-MM-DD')
              .hour(now.hour())
              .minute(now.minute())
              .second(now.second())
              .millisecond(now.millisecond())
          ))
      );
      if (
        values.length === 2
        && values[0] && values[0].isValid()
        && values[1] && values[1].isValid()
      ) {
        return values;
      }
    }
    return [
      (
        props.defaultDateFrom
          ? moment(props.defaultDateFrom)
          : now.clone().startOf('month')
      ),
      (
        props.defaultDateTo
          ? moment(props.defaultDateTo)
          : now.startOf('day')
      ),
    ];
  },
  getValueForQuery: (value) => {
    if (
      Array.isArray(value)
      && value.length === 2
      && value[0] && value[0].isValid()
      && value[1] && value[1].isValid()
    ) {
      // const now = moment();
      return `${value[0].format('YYYY-MM-DD')
        },${value[1].format('YYYY-MM-DD')
        }`;
    }
    return undefined;
  },
  // skip: [
  //   props => props.searchParams['period-span'] !== 'custom',
  // ],
  field: ['FieldDateRangePicker', {
    id: 'periodRange',
    name: 'periodRage',
    format: 'll',
    showToday: false,
    separator: '-',
    // skip: [
    //   props => props.searchParams?.['period-span'] !== 'custom',
    // ],
  }],
}];

const getValueForFieldDefault = (value) => (
  value && value.length ? value : undefined
);

// Search Filter
export const filterSearch = ['FilterField', {
  id: 'search',
  label: null,
  section: 'top',
  buildQuery: (value, builder) => value && builder.add(
    'where',
    {
      OR: [
        { name: { REGEX: value, OPTIONS: 'i' } },
         // eslint-disable-next-line max-len
        { 'location.city': { REGEX: value, OPTIONS: 'i' } },
      ],
    }
  ),
  getValueForField: (value) => value || '',
  getValueForQuery: (value) => {
    value = !value ? undefined : (value.target ? value.target.value : value);
    return !value || !value.length ? undefined : value;
  },
  field: ['FieldText', {
    name: 'search',
    placeholder: 'Search by name, address, or city',
  }],
}];

// Store Filter
export const filterStore = ['FilterField', {
  id: 'store',
  label: null,
  section: 'top',
  propsFromPage: (props) => ({ client: props.client }),
  buildQuery: (value, builder) => value && value.length && builder.add(
    'where',
    { store: { IN: isArray(value) ? value : [value] } },
  ),
  getValueForField: getValueForFieldDefault,
  field: ['FieldConnectionSelect', {
    name: 'store',
    url: '/stores/list',
    placeholder: 'Select Store',
    mode: 'multiple',
    allowClear: true,
    searchPaths: ['name'],
  }],
}];

// Country Filter
export const filterCountry = ['FilterField', {
  id: 'country',
  label: null,
  section: 'top',
  propsFromPage: (props) => ({ client: props.client }),
  buildQuery: (value, builder) => value && value.length && builder.add(
    'where',
    { 'location.country': { IN: isArray(value) ? value : [value] } },
  ),
  getValueForField: getValueForFieldDefault,
  field: ['FieldConnectionSelect', {
    name: 'countries',
    url: '/countries/list',
    placeholder: 'Select Country',
    mode: 'multiple',
    allowClear: true,
    searchPaths: ['name'],
  }],
}];

// City Filter
export const filterCity = ['FilterField', {
  id: 'city',
  label: null,
  section: 'top',
  buildQuery: (value, builder) => value && builder.add(
    'where',
    { 'location.city': { REGEX: value, OPTIONS: 'i' } },
  ),
  getValueForField: (value) => value || '',
  getValueForQuery: (value) => {
    value = !value ? undefined : (value.target ? value.target.value : value);
    return !value || !value.length ? undefined : value;
  },
  field: ['FieldText', {
    name: 'city',
    placeholder: 'Enter City',
  }],
}];

// System Country Filter
export const filterSystemCountry = ['FilterField', {
  id: 'systemCountry',
  label: null,
  section: 'top',
  buildQuery: (value, builder) => value && builder.add(
    'where',
    { systemCountry: { EQ: value } },
  ),
  getValueForField: (value) => value || '',
  field: ['FieldSelect', {
    name: 'systemCountry',
    placeholder: 'Select System Country',
    choices: [
      { label: 'United Arab Emirates', value: 'ae' },
      { label: 'Saudi Arabia', value: 'sa' },
      { label: 'Kuwait', value: 'kw' },
    ],
  }],
}];

// Pagination Filter
export const filterPagination = ['FilterPagination', {
  id: 'pagination',
  section: 'bottom',
}];

// Populate Store Filter
export const filterPopulateStore = ['FilterHidden', {
  id: 'populateStore',
  section: 'bottom',
  build: (builder) => builder.add('populate', { store: { name: true } }),
}];

export const filterScopeToSellerStore = ['FilterHidden', {
  id: 'scopeToSellerStore',
  build: builder => builder.add('custom', { scopeToSellerStore: true }),
}];

export const filterDateType = ['FilterField', {
  id: 'date',
  label: null,
  section: 'top',
  buildQuery: (value, builder, filter, _2, { pageProps }) => {
    const now = moment();
    let startDate;
    let endDate;
    if (value === 'created') {
      // First Cycle (6th - 20th)
      startDate = now.clone().date(6).startOf('day');
      endDate = now.clone().date(20).endOf('day');
      // Adjust for months where the current date is outside the range
      if (now.date() > 20) {
        startDate.add(1, 'month');
        endDate.add(1, 'month');
      }
    } else if (value === 'approved') {
      // Second Cycle (21st - 5th)
      startDate = now.clone().date(21).startOf('day');
      endDate = now.clone().add(1, 'month').date(5).endOf('day');
      // Adjust for months where the current date is outside the range
      if (now.date() < 6) {
        startDate.subtract(1, 'month');
        endDate.subtract(1, 'month');
      }
    }
    if (value
      && value.length) {
        // Add the date range to the query
        builder.add('where', {
          createdAt: {
            GTE: (
              filter.defaultDateFrom
                ? moment(filter.defaultDateFrom).toJSON()
                : now.clone().startOf('month').toJSON()
            ),
            LTE: (
              filter.defaultDateTo
                ? moment(filter.defaultDateTo).toJSON()
                : now.endOf('day').toJSON()
            ),
          },
        });
      }
  },
  getValueForField: value => (
    value && value.length
      ? value
      : 'created'
  ),
  field: ['FieldRadio', {
    name: 'date',
    label: null,
    initialValue: 'created',
    choices: [
      {
        label: 'First Cycle (6th - 20th)',
      },
      {
        label: 'Second Cycle (21st - 5th)',
      },
    ],
    Component: RadioComponent,
  }],
}];

export const filterSort = ['FilterField', {
  id: 'sort',
  label: null,
  section: 'top',
  VALUES_MAP: {
    createdAsc: { createdAt: 1 },
    createdDesc: { createdAt: -1 },
    approvedAsc: { approvedAt: 1 },
    approvedDesc: { approvedAt: -1 },
    shippedAsc: { shippedAt: 1 },
    shippedDesc: { shippedAt: -1 },
    completedAsc: { completedAt: 1 },
    completedDesc: { completedAt: -1 },
    amountAsc: { 'cost.charged': 1, createdAt: -1 },
    amountDesc: { 'cost.charged': -1, createdAt: -1 },
    balanceAsc: { balance: 1, createdAt: -1 },
    balanceDesc: { balance: -1, createdAt: -1 },
    ordersAsc: { orders: 1, createdAt: -1 },
    ordersDesc: { orders: -1, createdAt: -1 },
  },
  buildQuery: (value, builder, filter) => (
    filter.VALUES_MAP[value]
      ? builder.add('sort', { ...filter.VALUES_MAP[value] })
      : builder.add('sort', { ...filter.VALUES_MAP.createdDesc })
  ),
  getValueForField: getValueForFieldDefault,
  field: ['FieldSelect', {
    name: 'sort',
    placeholder: 'Sort',
    defaultValue: 'createdDesc',
    initialValue: 'createdDesc',
    prepareValueForInput: value => (value ? value : 'createdDesc'),
    choices: [{
      label: '↓ Date Created',
      value: 'createdDesc',
    }, {
      label: '↑ Date Created',
      value: 'createdAsc',
    }, {
      label: '↓ Balance',
      value: 'balanceDesc',
    }, {
      label: '↑ Balance',
      value: 'balanceAsc',
    },
    {
      label: '↑ Orders',
      value: 'ordersAsc',
    },
    {
      label: '↑ Orders',
      value: 'ordersDesc',
    },
  ],
  }],
}];

// Export All Filters
export const ADMIN = [
  ...[
    // [filterDateType, 24],
    [filterSort, 8],
    [generateCycleButton, 8],
    [filterPeriodRange, 24],
  ].map((args) => getFilterWithCol(...args)),

  filterPagination,
  filterPopulateStore,
];
// Export All Filters
export const SELLER = [
  ...[
    [filterSearch, 8],
    [filterSortCreatedUpdatedName, 8],
    [filterCountry, 12],
    [filterCity, 12],
  ].map((args) => getFilterWithCol(...args)),

  filterPagination,
  filterPopulateStore,
  filterScopeToSellerStore,
];
